import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Paper, Button, Typography, CircularProgress } from '@mui/material';
import { BRAND_COLORS } from '../styles/theme';
import { useTranslation, LanguageSwitcher } from '../i18n';
import { useAuthV2 } from '../contexts/AuthContextV2';
import XERLogo from '../components/XERLogo';

export const PendingApprovalPage: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { isLoading } = useAuthV2();

  const handleBackToLogin = () => {
    // Only navigate when auth is done initializing to avoid getting stuck on loading screen
    if (!isLoading) {
      navigate('/');
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundImage: 'url(/login-bg.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        padding: 2,
        position: 'relative',
      }}
    >
      {/* Language Switcher - top right */}
      <Box sx={{ position: 'absolute', top: 16, right: 16 }}>
        <LanguageSwitcher variant="compact" />
      </Box>

      <Paper
        elevation={3}
        sx={{
          padding: 4,
          maxWidth: 450,
          width: '100%',
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
          boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.2)',
          border: '1px solid rgba(255, 255, 255, 0.3)',
          backdropFilter: 'blur(8px)',
          textAlign: 'center',
        }}
      >
        {/* Logo */}
        <Box sx={{ mb: 3 }}>
          <XERLogo width={120} height={50} />
        </Box>

        <Typography
          variant="h5"
          sx={{
            color: BRAND_COLORS.forestGreen.main,
            mb: 2,
            fontWeight: 600,
          }}
        >
          {t('noOrganization.title')}
        </Typography>

        <Typography
          variant="body1"
          sx={{
            color: '#666',
            mb: 4,
          }}
        >
          {t('noOrganization.message')}
        </Typography>

        <Button
          fullWidth
          variant="contained"
          onClick={handleBackToLogin}
          disabled={isLoading}
          sx={{
            backgroundColor: BRAND_COLORS.forestGreen.main,
            '&:hover': {
              backgroundColor: '#002B20',
            },
          }}
        >
          {isLoading ? <CircularProgress size={24} color="inherit" /> : t('auth.backToLogin')}
        </Button>
      </Paper>
    </Box>
  );
};

export default PendingApprovalPage;
